import {createContext} from 'react';
import {Account} from "../features/accounts/types.ts";


type UserAccountContextType = {
    userAccount: Account | undefined,
}


export const UserAccountContext = createContext<UserAccountContextType>({
                                                                            userAccount: {} as Account,
                                                                        });

